import { render, staticRenderFns } from "./CommentsComponent.vue?vue&type=template&id=3a666a59&scoped=true"
import script from "./CommentsComponent.vue?vue&type=script&lang=js"
export * from "./CommentsComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentsComponent.vue?vue&type=style&index=0&id=3a666a59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a666a59",
  null
  
)

export default component.exports